import React, { Fragment } from "react";

export function PinPromptWithDisplay({
  pin,
  placeHolder,
}: {
  pin: string;
  placeHolder: string;
}) {
  return (
    <div className="flex-container row pl-5" style={styles.pinContainer}>
      {pin ? (
        pin.split("").map((_, index) => (
          <Fragment key={index}>
            <span style={styles.pinText}>{"•"}</span>

            {/* <Text style={styles.floatingLabel}>{placeHolder}</Text> */}
          </Fragment>
        ))
      ) : (
        <span style={styles.pinText}>{placeHolder}</span>
      )}
    </div>
  );
}

const styles = {
  pinContainer: {
    // flexDirection: "row",
    alignItems: "flex-end",
    backgroundColor: "lightgray",
    // marginBottom: 10,
    // marginTop: 10,
    opacity: 0.5,
    // borderBottomWidth: 1,
    borderBottomColor: "#062156",
    borderRadius: 3,
    cursor: "pointer",
  },
  pinText: {
    fontSize: 14,
    marginRight: 5,
    paddingTop: 20,
    paddingBottom: 5,
  },
  floatingLabel: {
    position: "absolute",
    top: 0,
    left: 0,
    fontSize: 12,
    color: "#8E8E93",
    opacity: 0.5,
    paddingHorizontal: 10,
  },
};
